
import get from 'lodash/get';

import useProjectDefinition from './useProjectDefinition';

export default function useDisableEditMsg() {
    const projectDefinition = useProjectDefinition();
    return get(projectDefinition, 'app.disableEditMsg');
}
